















































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import { DataApi } from '../models/Add.model';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';

import { fetchAdd } from '../fetchAdd';

import { paramApiGenerarEncomienda } from '../models/Add.model';
import { log } from 'console';

@Component({ components: { DatePicker } })
export default class TabEncomienda extends Vue {
  //@Prop({ required: true, default: false }) show!: boolean;
  @Prop({ required: true, default: {} }) data!: DataApi;

  show: boolean = true;
  readonly loadingService: LoadingService = new LoadingService();
  readonly $snotify: Snotify = null;
  dialog: boolean = false;
  loading: boolean = false;
  disabled: boolean = true;

  activateChange: boolean = false;
  paramApi: paramApiGenerarEncomienda = {
    despanumero: 'Por Asignar',
    despafecha_envia: '',
    courrier: {
      configid: '',
      configvalor: '',
    },
    despaseguimiento: '',
    localidad: {
      locaid: '',
      locaname: '',
      locabaja: '',
    },
    tecnico: {
      tecnicoid: '',
      tecniconame: '',
      estado: '',
    },
    usuario: {
      id: '',
      nombre: '',
      rut: '',
    },
    despaobs: '',
    despacargo_sino: false,
    despacargo_valor: '',
    despafecha_recibe: '',
    despareceptor: '',
  };

  listApi: Record<string, any[]> = {
    tecnicos: [],
    localidades: [],
    courriers: [],
  };

  async mounted() {
    try {
      this.loading = true;
      this.loadingService.showLoading(null, 'addGenerarEncomienda');
      this.dialog = this.show;
      await Promise.all([this.getFilters(), this.getValues()]);
    } catch (error) {
      console.error('Error con el modal: ', error);
    } finally {
      this.loading = false;
      this.loadingService.hideLoading('addGenerarEncomienda');
    }
  }

  async getValues(): Promise<void> {
    try {
      const result = await fetchAdd({
        endpoint: 'get_encomienda',
        body: { nombre_add: this.data.nombre_add },
      });
      const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);
      if (cod !== 1) {
        this.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
      }
      if (Object.keys(LISTA[0]).length === 0) return;
      this.disabled = false;
      const {
        despanumero,
        nombre_add,
        despafecha_envia,
        despacourrier,
        despaseguimiento,
        locaid,
        tecnicoid,
        usuarioid_alta,
        usuariorut_alta,
        nombre,
        despaobs,
        despacargo_sino,
        despacargo_valor,
        despafecha_recibe,
        despareceptor,
      } = LISTA[0];

      // Valores iniciales
      this.paramApi.despanumero = despanumero;
      this.paramApi.nombre_add = nombre_add;
      this.paramApi.despafecha_envia = moment(despafecha_envia);
      this.paramApi.courrier.configid = despacourrier;
      this.paramApi.despaseguimiento = despaseguimiento;
      this.paramApi.localidad.locaid = locaid;
      this.paramApi.tecnico.tecnicoid = tecnicoid;
      this.paramApi.usuario.id = usuarioid_alta;
      this.paramApi.usuario.rut = usuariorut_alta;
      this.paramApi.usuario.nombre = nombre;
      this.paramApi.despaobs = despaobs;
      const valDespacargo = Number(despacargo_sino) === 1 ? true : false;
      this.paramApi.despacargo_sino = valDespacargo;
      this.paramApi.despacargo_valor = despacargo_valor;
      this.paramApi.despafecha_recibe = despafecha_recibe
        ? moment(despafecha_recibe)
        : '';
      this.paramApi.despareceptor = despareceptor;
    } catch (error) {
      console.error('Error iniciando los valores: ', error);
    }
  }

  async getFilters(): Promise<void> {
    try {
      const userId = JSON.parse(
        window.localStorage.getItem('user').replace(/'/g, '"')
      ).id;

      const result = await fetchAdd({
        serviceClient: 'conectaDespacho',
        endpoint: 'getFilter',
        body: { user_id: userId },
      });
      const {
        CODIGO_RESPUESTA,
        MENSAJE_RESPUESTA,
        TECNICO,
        LOCALIDAD,
        CURRIER,
        USER,
      } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);
      if (cod !== 1) {
        this.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
        return;
      }

      // Valores de los filtros
      this.listApi.tecnicos = TECNICO.filter(
        (tecnico: any) => tecnico.estado != '1'
      );
      this.listApi.localidades = LOCALIDAD.filter(
        (localidad: any) =>
          localidad.locabaja !== 't' &&
          !localidad.locaname
            .trim()
            .toLowerCase()
            .includes('santiago')
      );
      this.listApi.courriers = CURRIER;

      // Valores inciiales
      this.paramApi.usuario = USER[0];

      const findTecnico = TECNICO.find(
        (tecnico: any) => tecnico.tecnicoid === this.data.tecnicoid
      );

      if (findTecnico) {
        this.paramApi.tecnico = findTecnico;
      }
    } catch (err) {
      console.error('Error: ', err);
    }
  }
}
